import { OutdoorEngagementResolutionCategory } from '../api/models'

const outdoorEngagementResolutionCategoryDisplayNames: Record<OutdoorEngagementResolutionCategory, string> = {
  [OutdoorEngagementResolutionCategory.Violence]: 'Violence',
  [OutdoorEngagementResolutionCategory.ForcedEntry]: 'Forced Entry',
  [OutdoorEngagementResolutionCategory.Flames]: 'Flames',
  [OutdoorEngagementResolutionCategory.VehicleTampering]: 'Vehicle Tampering',
  [OutdoorEngagementResolutionCategory.PackageRemoval]: 'Package Removal',
  [OutdoorEngagementResolutionCategory.PropertyDamage]: 'Property Damage',
  [OutdoorEngagementResolutionCategory.MiscSuspiciousBehavior]: 'Misc Suspicious Behavior',
  [OutdoorEngagementResolutionCategory.MedicalDistress]: 'Medical Distress',
  [OutdoorEngagementResolutionCategory.RequestedPolice]: 'Requested Police',
  [OutdoorEngagementResolutionCategory.RequestedFireDept]: 'Requested Fire Dept',
  [OutdoorEngagementResolutionCategory.RequestedMedicalServices]: 'Requested Medical Services',
  [OutdoorEngagementResolutionCategory.RequestedHelp]: 'Requested Help',
  [OutdoorEngagementResolutionCategory.ClearedBySystemTriage]: 'Cleared By System Triage',
  [OutdoorEngagementResolutionCategory.ClearedByAI]: 'Cleared By AI',
  [OutdoorEngagementResolutionCategory.ClearedByCustomer]: 'Cleared By Customer',
  [OutdoorEngagementResolutionCategory.IntrusionMonitoringTakeover]: 'Intrusion Monitoring Takeover',
  [OutdoorEngagementResolutionCategory.NoVideoAvailable]: 'No Video Available',
  [OutdoorEngagementResolutionCategory.Obsolete]: 'Obsolete',
  [OutdoorEngagementResolutionCategory.RecentlyArmed]: 'Recently Armed',
  [OutdoorEngagementResolutionCategory.Passerby]: 'Passerby',
  [OutdoorEngagementResolutionCategory.NeighborActivity]: 'Neighbor Activity',
  [OutdoorEngagementResolutionCategory.UndressedPersonInside]: 'Undressed Person Inside',
  [OutdoorEngagementResolutionCategory.CameraIsInside]: 'Camera Is Inside',
  [OutdoorEngagementResolutionCategory.IndoorMotion]: 'Indoor Motion',
  [OutdoorEngagementResolutionCategory.VehicleTraffic]: 'Vehicle Traffic',
  [OutdoorEngagementResolutionCategory.NoPerson]: 'No Person',
  [OutdoorEngagementResolutionCategory.OngoingIncident]: 'Ongoing Incident',
  [OutdoorEngagementResolutionCategory.Delivery]: 'Delivery',
  [OutdoorEngagementResolutionCategory.PackagePickupUniformed]: 'Package Pickup Uniformed',
  [OutdoorEngagementResolutionCategory.UniformedAuthorities]: 'Uniformed Authorities',
  [OutdoorEngagementResolutionCategory.UnfamiliarPersonBriefView]: 'Unfamiliar Person Brief View',
  [OutdoorEngagementResolutionCategory.VehicleArrivedNobodyExited]: 'Vehicle Arrived Nobody Exited',
  [OutdoorEngagementResolutionCategory.LoudOutdoorService]: 'Loud Outdoor Service',
  [OutdoorEngagementResolutionCategory.FamiliarPersonOnProperty]: 'Familiar Person On Property',
  [OutdoorEngagementResolutionCategory.UnfamiliarPersonOnProperty]: 'Unfamiliar Person On Property',
  [OutdoorEngagementResolutionCategory.UnfamiliarUnattendedMinor]: 'Unfamiliar Unattended Minor',
  [OutdoorEngagementResolutionCategory.OccupiedVehicleNobodyExited]: 'Occupied Vehicle Nobody Exited',
  [OutdoorEngagementResolutionCategory.Halloween]: 'Halloween'
}

export function getOutdoorEngagementResolutionCategoryDisplayName(category: OutdoorEngagementResolutionCategory | undefined): string {
  return category ? outdoorEngagementResolutionCategoryDisplayNames[category] : ''
}
